var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vtk-graphics-container"}},[_vm._t("vtk",[_c('div',{ref:"vtk-graphics-container"},[_c('canvas',{ref:"vtk-text-container"})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }